module.exports = __webpack_public_path__ + "static/fonts/iconfont.ddfbb65a.ttf";